import Style from "@client/controls/HTML/Style/component";
import { getFontFamilyName } from "@client/lib/settings";
import { adjustLineHeight } from "@client/lib/text";
import { getLayoutSettingValueSelector } from "@client/selectors";
import styleSheetSelectors from "@client/selectors/advanced/styleSheet";
import { colorToRGBA, parseColor } from "@common/lib/color";
import React from "react";
import { useSelector } from "react-redux";

export default () => {
  const color = useSelector(styleSheetSelectors.colors.primary);
  const headerHeight = useSelector(getLayoutSettingValueSelector("height", "header"));
  const text = useSelector(styleSheetSelectors.typography.text)!;
  const textColor = useSelector(styleSheetSelectors.colors.text);

  const backgroundColor = React.useMemo(() => {
    const pc = parseColor(color)!;
    pc.a = 0.1;
    return colorToRGBA(pc);
  }, [color]);

  const highlightBackgroundColor = React.useMemo(() => {
    const pc = parseColor(color)!;
    pc.a = 0.05;
    return colorToRGBA(pc);
  }, [color]);

  const css = React.useMemo(
    () => `body {
      --color: ${color};
      --background-color: ${backgroundColor};
      --highlight-background-color: ${highlightBackgroundColor};
      --header-height: ${headerHeight ?? "0px"};

      --font-family: ${getFontFamilyName(text.font)}, Helvetica, Arial;
      --font-weight: ${text.weight};
      --font-size: ${text.size};
      --line-height: ${adjustLineHeight(text.line)};
      --letter-spacing: ${text.letter};
      --text-color: ${textColor};
    }`,
    [backgroundColor, headerHeight, highlightBackgroundColor, color, text, textColor]
  );

  return <Style css={css} />;
};
